import PromModel from '@/models/Prom';
import ProdModel from '@/models/Prod';

const GET_QRPAGE = 'GET_QRPAGE';
const ACCESS_QRPAGE = 'ACCESS_QRPAGE';
const COLLECT_QRPAGE = 'COLLECT_QRPAGE';
const CHECK_QRPAGE = 'CHECK_QRPAGE';
const GET_QR_MINI_CONFIG = 'GET_QR_MINI_CONFIG';
const QUERY_PRODUCT_LIST = 'QUERY_PRODUCT_LIST';

// 查看
async function getQrpage(params) {
  const payload = await new PromModel().getQrpage(params);
  return {
    type: GET_QRPAGE,
    payload
  };
}

// 获取产品列表
async function queryProductList(params) {
  const payload = await new ProdModel().queryProductList(params);
  return {
    type: QUERY_PRODUCT_LIST,
    payload
  };
}

// 访问页面
async function accessQrpage(params) {
  const payload = await new PromModel().accessQrpage(params);
  return {
    type: ACCESS_QRPAGE,
    payload
  };
}

// 收藏&取消
async function collectQrpage(params) {
  const payload = await new PromModel().collectQrpage(params);
  return {
    type: COLLECT_QRPAGE,
    payload
  };
}

// 校验
async function checkQrpage(params) {
  const payload = await new PromModel().checkQrpage(params);
  return {
    type: CHECK_QRPAGE,
    payload
  };
}

// 基础配置
async function getQrMiniConfig(params) {
  const payload = await new PromModel().getQrMiniConfig(params);
  return {
    type: GET_QR_MINI_CONFIG,
    payload
  };
}

const ACTION_TYPES = {
  GET_QRPAGE,
  ACCESS_QRPAGE,
  COLLECT_QRPAGE,
  CHECK_QRPAGE,
  GET_QR_MINI_CONFIG,
  QUERY_PRODUCT_LIST
};

const ACTION = {
  getQrpage,
  accessQrpage,
  collectQrpage,
  checkQrpage,
  getQrMiniConfig,
  queryProductList
};

const Qrpage = {
  ACTION_TYPES,
  ACTION
};

export default Qrpage;
